export const ProcessIssuesStatusStringMap = new Map<string, string>([
  //Pipeline
  ['PENDING_APPROVAL', 'Pending Approval'],
  ['PUBLISHED', 'Published '],
  ['APPROVED', 'Approved'],
  ['ERRORS', 'Errors'],
  //Connectors
  ['SUCCESS', 'Success'],
  ['PENDING', 'Pending Approval'],
  ['AUTOMATED', 'Automated'],
  ['NEED_SCHEMA_APPROVAL', 'Need Schema Approval'],
  ['PENDING_NEXT_RUN', 'Pending Next Run'],
  ['PENDING_SCHEMA_APPROVAL', 'Pending Schema Approval'],
  ['FAILURE', 'Failure'],
  ['DELETED', 'Deleted'],
  ['QUEUED', 'Queued'],
  ['RUNNING', 'Running'],
  ['PAUSING', 'Pausing'],
  ['RESUMING', 'Resuming'],
  ['PAUSED', 'Paused'],
  //Data Sources
  ['PENDING_TECHNICAL_DETAILS', 'Pending Technical Details'],
  ['PENDING_CONNECTION', 'Pending Connection'],
  ['UPDATE_CATALOG', 'Update Catalog'],
  ['CONNECTED', 'Connected'],
  ['DISCOVERY', 'Discovery'],
  ['CONNECTION_FAILED', 'Connection Failed'],
  ['UNDER_DISCOVER', 'Under Discovery'],
  ['NEW', 'New'],
  ['CATALOGUED', 'Catalogued'],
  ['DISCOVERY_INCOMPLETE', 'Discovery Incomplete'],
  ['CATALOG_INCOMPLETE', 'Catalog Incomplete'],
]);
